import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfile.vue?vue&type=template&id=cfe2a004&"
import script from "./MoleculeEditionAcademyUsersProfile.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports